const matchesKeywords = (message, keywords) => {
    if (!message || typeof message !== "string") return false;
    const lower = message.toLowerCase();
    return keywords.some((kw) => lower.includes(kw.toLowerCase()));
};

export const isAppointmentLimitError = (message) =>
    matchesKeywords(message, [
        "Você atingiu o número máximo de agendamentos permitido no seu plano. Por favor faça o upgrade",
        "You have reached the maximum number of appointments allowed on your plan. Please upgrade",
        "Has alcanzado el número máximo de citas permitidas en tu plan. Por favor, actualiza tu plan.",
    ]);

export const isAdvanceNoticeError = (message) =>
    // TODO: adicionar variantes EN/ES quando backend fornecer
    matchesKeywords(message, [
        "O horário inicial da reserva é maior que o horário de antecedência criado pelo estabelecimento",
    ]);

export const isProfessionalWithNoAgendaError = (message) =>
    // TODO: adicionar variantes EN/ES quando backend fornecer
    matchesKeywords(message, [
        "Profissional não tem uma agenda",
    ]);
